/*
 ReplyCard component
 url match: /dashboard
 Base component for the home page, redirects to appropriate 
 components depending on the URL/Route
*/
import { withRouter } from 'react-router-dom';
import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Loader from 'react-loader-spinner'
import { replyStyles } from '../../../Styles/chatStyles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import { ReactSVG } from 'react-svg';
import Images from '../../../Theme/Images';
import TextField from '@material-ui/core/TextField';
import ChatAttachmentPreview from './ChatAttachmentPreview';
const acceptedFiles = ['image/gif', 'image/jpeg', 'image/png', 'application/pdf', 'application/zip'];

@inject('userStore', 'commonStore', 'chatStore')
@observer
class ReplyCard extends React.Component {
    state = {
        showTextField: true,
        comment: '',
        files: [],
        mail: false,
        whatsapp: false,
        suggestedText: ''
    }

    constructor() {
        super()
        this.inputOpenFileRef = React.createRef()
    }

    openFileModal = () => {
        const { type, showPassword, password } = this.state;

        this.inputOpenFileRef.current.click();
    }

    clearFiles = (index) => {
        let temp = this.state.files.slice();
        temp.splice(index, 1);

        this.setState({ files: temp })
        if (temp.length < 1)
            this.cancelUpload()
    }

    cancelUpload = () => {
        this.props.chatStore.setAttachmentPreview(false)
        this.setState({ files: [] })
    }

    onChangeFile = (event, type) => {
        event.stopPropagation();
        event.preventDefault();
        var files = event.target.files;
        if (!files.length)
            return
        else {
            let temp = []
            Array.from(files).forEach(x => {
                console.log(x.type)
                if (!acceptedFiles.includes(x.type.toLowerCase())) {
                    this.props.commonStore.handleOpenSnackBar('Only image and PDF files are allowed!', 'info')
                    return
                }
                x.myUrl = URL.createObjectURL(x)
                temp.push(x)
            })
            let newFilesArray = this.state.files.slice();
            newFilesArray = newFilesArray.concat(temp)
            if (newFilesArray.length > 10)
                this.props.commonStore.handleOpenSnackBar('Only 10 or less attachments are allowed per reply!', 'info')
            else {
                this.setState({ files: newFilesArray })
            }
            this.props.chatStore.setAttachmentPreview(true)
        }
        event.target.value = ''
    }

    scrollToBottom = () => {
        var elem = document.getElementById('myscrollingChat');
        if (elem != null)
            elem.scrollTop = elem.scrollHeight - elem.offsetHeight;
    }

    replyToChat = () => {
        const { comment, files, mail } = this.state;
        const { currentTicket, replyProgress } = this.props.chatStore;
        if ((files.length || comment.length) && !replyProgress) {
            this.props.chatStore.sendMessage(files, comment.length ? comment : undefined)
                .then(() => {
                    this.props.chatStore.setAttachmentPreview(false)
                    this.props.resetPage()
                    if (!this.props.chatStore.replyProgress) {
                        this.setState({ comment: '', files: [] });
                        this.scrollToBottom();
                    }

                })
            this.setState({ files: [] })
        }

        else {
            this.props.commonStore.handleOpenSnackBar("Please add a comment/attach file before proceeding to send", 'info')
        }
    }

    onPressEnter = (event) => {
        const { comment, suggestedText } = this.state;
        if (event.keyCode === 9 && suggestedText.length > 1) {
            event.preventDefault()
            this.setState({
                comment: this.state.comment + suggestedText,
                suggestedText: '',

            })
        }

        //If backspace key is pressed
        else if (event.keyCode === 8) {
            if (comment.length < 4)
                this.setState({
                    suggestedText: '',
                })
        }
        if (event.which === 13) {
            event.preventDefault();
            this.replyToChat()
        }
    }

    actionButtons = () => {
        const { classes } = this.props;
        const { comment } = this.state
        return (
            <div className={classes.actionItems}>
                {
                    comment.trim().length ?
                        <ReactSVG className={classes.actionButton} onClick={(e) => this.replyToChat()} src={Images.send} /> :
                        <ReactSVG className={classes.actionButton} onClick={(e) => this.openFileModal(e)} src={Images.attachment} />

                }
                <input
                    type="file"
                    multiple
                    style={{ display: "none" }}
                    ref={this.inputOpenFileRef}
                    accept="image/x-png,image/gif,image/jpeg,.pdf,.doc,.zip,.rar,.7zip"
                    onChange={(e) => this.onChangeFile(e, false)}
                />
            </div>
        )
    }

    startTyping = (e) => {
        const { comment } = this.state;
        this.setState({ comment: e.target.value })
        this.props.chatStore.indicateTyping(this.props.chatStore.chatData.sessionId.toString())
        const { chatStore } = this.props;
        this.setState({
            comment: e.target.value,
        })
    }

    renderInputField = () => {
        const { classes } = this.props;
        const { autoSuggestion } = this.props.chatStore;
        const { comment, files, suggestedText } = this.state;
        return (
            <React.Fragment>
                {files.length ? <ChatAttachmentPreview files={files} clearFiles={this.clearFiles} upload={this.replyToChat} cancelUpload={this.cancelUpload} /> : null}
                <div className={classes.replyInput}>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <input id="textInput" name="input-message" autoFocus={true} placeholder={'Type a new message'} onChange={this.startTyping} value={comment} onKeyDown={(event) => { this.onPressEnter(event) }}></input>
                    </div>
                    {this.actionButtons()}

                </div>

            </React.Fragment>
        )
    }

    render() {
        const { classes, theme } = this.props;
        const { showTextField, comment, files, mail, whatsapp } = this.state;
        const { chatData, startChatLoading } = this.props.chatStore;
        return (
            !showTextField ?
                <Card className={classes.replyCard} >
                    <CardContent classes={{ root: classes.cardContent }}>
                        <div className="rowFlex">
                            <div onClick={(e) => this.setState({ showTextField: true })} className={classes.actionButton} ><ReactSVG src={Images.reply} /><span className={classes.vertCenter}>Reply</span></div>
                            <div onClick={(e) => this.setState({ showTextField: true })} className={classes.actionButton} ><ReactSVG src={Images.note} /><span className={classes.vertCenter}>Add note</span></div>
                        </div>
                    </CardContent>
                </Card>
                :
                <div className={classes.replyCard} onClick={(e) => this.props.commonStore.showOnlyTextBox(false)}>
                    {
                        this.renderInputField()
                    }
                </div>
        )
    }
}
export default withStyles(replyStyles, { withTheme: true })(withRouter(ReplyCard));
